import { Col } from "@ir/ui";

interface DeductionFilterInfoColProps {
  children: React.ReactNode;
  span?: number;
  md?: number;
}

const FilterInfoCol = ({ children, span = 6, md = 6 }: DeductionFilterInfoColProps) => {
  return (
    <Col span={span} md={md}>
      {children}
    </Col>
  );
};

export default FilterInfoCol;
